"use client";

import React from "react";

import styles from "@/components/common/QuizBanner/QuizBanner.module.scss";
import QuizBannerAnimation from "@/components/common/QuizBanner/QuizBannerAnimation";
import { ButtonNova } from "@/components/ui-kit/ButtonNova/ButtonNova";
import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";
import { useNavigation } from "@/hooks/useNavigation";
import { QuizBannerData } from "@/types/common";
import { GA4 } from "@/utils/ga4Utils";
import { cn } from "@/utils/general";

interface QuizBannerProps {
  data?: QuizBannerData;
}

const QuizBanner: React.FC<QuizBannerProps> = ({ data }) => {
  const navigate = useNavigation();
  const handleCtaClick = () => {
    GA4.onMarketingCtaClicked({
      destination: "/hair/brand/quiz/",
      module_location: "mid_fold",
      module_name:
        data?.bannerText ||
        "Not sure where to start? Uncover what you need to support hair growth.",
      type: "button",
      text: "Take the Quiz",
    });
    navigate("/hair/brand/quiz/");
  };

  return (
    <div className="flex flex-col lg:flex-row rounded overflow-hidden bg-nova-base-black relative">
      <div
        className={`
          relative z-1 bg-nova-base-black gap-8 md:gap-10 lg:gap-8 w-full lg:w-1/2 
          px-6 sm:px-6 md:px-8 lg:px-20 pt-10 sm:pt-10 md:pt-0 lg:pt-20 pb-10 sm:pb-10 
          md:pb-12 lg:pb-20 order-2 lg:order-1 -mt-px lg:mt-0 flex flex-col sm:flex-col 
          md:flex-row lg:flex-col items-start sm:items-start md:items-center lg:items-start`}
      >
        <div className="flex-1 mx-auto md:mx-0 text-center md:text-left">
          {data?.heading && (
            <TextElementNova
              element="h2"
              text={data.heading}
              className={cn(
                "Subtitle-20-Dia-Normal text-nova-base-white mb-8 md:mb-2 lg:mb-8",
                data?.headingClasses
              )}
            />
          )}
          {data?.copy && (
            <TextElementNova
              text={data.copy}
              className={cn(data.copyClasses ?? "Body-30-Dia-Normal text-nova-base-white")}
              classes={data.copyTextClasses ?? undefined}
            />
          )}
        </div>
        <div className="mx-auto sm:ml-auto md:ml-0">
          <ButtonNova
            onClick={handleCtaClick}
            label={data.buttonText ?? "Take the Quiz"}
            icon={"Right"}
            level={"Primary"}
            className="quiz-cta"
          />
        </div>
      </div>
      <div
        className={cn(
          styles.animationArea,
          "w-full lg:w-1/2 order-1 lg:order-2 relative overflow-hidden"
        )}
      >
        <QuizBannerAnimation backgroundImage={data?.backgroundImage} />
      </div>
    </div>
  );
};

export default QuizBanner;
